import React from 'react'
import IconBase from './IconBase'

const Logo = props =>
  <IconBase viewBox="0 0 344.7 342.9" {...props}>
    <path fill="#F2F19E" d="m321.6 85.8c-47.6-82-153-110.1-235.4-62.8s-110.7 152.2-63.1 234.2 153 110.1 235.4 62.8 110.7-152.2 63.1-234.2zm-149.2 182.1c-53.5 0-97-43.2-97-96.5s43.4-96.5 97-96.5 97 43.2 97 96.5c-0.1 53.3-43.5 96.5-97 96.5z"/>
    <path fill="#ABD495" d="M123.9,87.9L86.2,23C31,54.7,0.1,112.3,0,171.5l75.4,0C75.4,135.8,94.9,104.6,123.9,87.9z"/>
    <path fill="#84BFD8" d="m75.4 171.5h-75.4c0 29.1 7.4 58.7 23.1 85.7s37.7 48.2 63.1 62.8l37.7-65c-29-16.7-48.5-47.8-48.5-83.5z"/>
    <path fill="#9A8EC5" d="m172.4 267.9c-17.7 0-34.2-4.7-48.5-12.9l-37.7 65c51.6 29.5 117.1 31.7 172.3 0l-37.7-65c-14.2 8.2-30.8 12.9-48.4 12.9z"/>
    <path fill="#D59093" d="m269.3 171.5c0 35.7-19.5 66.9-48.5 83.5l37.7 64.9c55.2-31.7 86.1-89.3 86.2-148.5l-75.4 0.1z"/>
    <path fill="#DCB288" d="m269.3 171.5h75.4c0-29.1-7.4-58.7-23.1-85.7s-37.7-48.2-63.1-62.8l-37.7 65c29 16.6 48.5 47.8 48.5 83.5z"/>
    <rect x="981" y="374.6" width="1417.2" height="89.5" fill="none"/>
    <text transform="translate(980.97 445.64)" display="none" fill="#FFFFFF" fontFamily="'MyriadPro-Regular'" fontSize="100px">Gratis app til dig og din forening</text>
  </IconBase>

export default Logo
